import { createContext } from 'react'
import type { NotificationItem } from '#src/hooks/useNotificationItems.ts'

export type GetSiblingsFn = (item: NotificationItem) => NotificationItem[]

/*
 * Provides a function to look up sibling notifications that share the same
 * underlying resource as a given notification. Used to cascade inbox actions
 * (archive, read, unread) to all dedup-hidden siblings.
 */
export const InboxSiblingsContext = createContext<GetSiblingsFn | null>(null)
